import React from "react";
import { Icon } from "@iconify/react";
import AuthForm from "../AuthForm";
import Logo from "../../components/Logo";
import { useLanding } from "../landingTheme";

export default function AuthPage() {
  // จุดขายใต้โลโก้ใช้ชุดเดียวกับป้ายในการ์ดต้อนรับหน้าแรก (แอดมินแก้ได้ที่ ปรับแต่งหน้าเว็บ)
  const { cfg } = useLanding();
  const points = cfg.hero.badges || [];
  return (
    <div className="vx-authpage">
      <aside className="vx-auth-art">
        <div className="vx-auth-rays" aria-hidden="true" />
        <div className="vx-auth-emoji" aria-hidden="true">
          <Icon icon="fluent-emoji-flat:trophy" className="a1" />
          <Icon icon="fluent-emoji-flat:four-leaf-clover" className="a2" />
          <Icon icon="fluent-emoji-flat:gem-stone" className="a3" />
          <Icon icon="fluent-emoji-flat:money-bag" className="a4" />
        </div>
        <div className="vx-auth-logo">
          <Logo customSize={64} />
        </div>
        <h1 className="vx-auth-title">
          ยินดีต้อนรับ
          <b>เริ่มลุ้นโชคได้เลย</b>
        </h1>
        {!!points.length && (
          <ul className="vx-auth-points">
            {points.map((p) => (
              <li key={`${p.icon}-${p.label}`}>
                <Icon icon={p.icon} width={18} height={18} />
                {p.label}
              </li>
            ))}
          </ul>
        )}
      </aside>

      <div className="vx-auth-form">
        <AuthForm />
        <p className="lx-muted vx-auth-note">การสมัคร = ยอมรับเงื่อนไขการใช้งาน · เล่นอย่างมีสติ</p>
      </div>
    </div>
  );
}
